import { TableColumn } from './shared/table.constants';

export const CITIES_COLUMNS: TableColumn[] = [
  { id: 'actions', title: '', className: 'w-1/12' },
  { id: 'id', title: 'id' },
  { id: 'name', title: 'city' },
  { id: 'countryName', title: 'country', className: 'last:text-left' },
];
